// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Op} from './op.js'

export class ReceiveOpsEvent {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ReceiveOpsEvent {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsReceiveOpsEvent(bb: flatbuffers.ByteBuffer, obj?: ReceiveOpsEvent): ReceiveOpsEvent {
    return (obj || new ReceiveOpsEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsReceiveOpsEvent(bb: flatbuffers.ByteBuffer, obj?: ReceiveOpsEvent): ReceiveOpsEvent {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ReceiveOpsEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  ops(index: number, obj?: Op): Op | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset
      ? (obj || new Op()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!)
      : null
  }

  opsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  expectedAckReply(): string | null
  expectedAckReply(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  expectedAckReply(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  schemaVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
  }

  static startReceiveOpsEvent(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addOps(builder: flatbuffers.Builder, opsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, opsOffset, 0)
  }

  static createOpsVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startOpsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addExpectedAckReply(builder: flatbuffers.Builder, expectedAckReplyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, expectedAckReplyOffset, 0)
  }

  static addSchemaVersion(builder: flatbuffers.Builder, schemaVersion: number) {
    builder.addFieldInt16(2, schemaVersion, 0)
  }

  static endReceiveOpsEvent(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // ops
    builder.requiredField(offset, 6) // expected_ack_reply
    return offset
  }

  static createReceiveOpsEvent(
    builder: flatbuffers.Builder,
    opsOffset: flatbuffers.Offset,
    expectedAckReplyOffset: flatbuffers.Offset,
    schemaVersion: number
  ): flatbuffers.Offset {
    ReceiveOpsEvent.startReceiveOpsEvent(builder)
    ReceiveOpsEvent.addOps(builder, opsOffset)
    ReceiveOpsEvent.addExpectedAckReply(builder, expectedAckReplyOffset)
    ReceiveOpsEvent.addSchemaVersion(builder, schemaVersion)
    return ReceiveOpsEvent.endReceiveOpsEvent(builder)
  }
}
